<template>
  <div class="main frame-inside">
    <div class="frame-bg">
      <img
        class="frame-img"
        :class="{ zoom: startZoom }"
        src="/assets/images/frame-inside.webp"
        alt
      />
      <img
        class="img-overlay"
        :class="{ shadow: hoverBook, 'd-none': startZoom }"
        src="/assets/images/book.webp"
        alt
      />
      <img
        class="img-overlay"
        :class="{ shadow: hoverDoor, 'd-none': startZoom }"
        src="/assets/images/door.webp"
        alt
      />
      <map name="mapframe">
        <area
          shape="rect"
          coords="845,810,1020,900"
          href="#"
          @click="showModal"
          @mouseover="hoverBook = true"
          @mouseleave="hoverBook = false"
        />
        <area
          shape="rect"
          coords="840,310,1050,710"
          href="#"
          @click="startOut"
          @mouseover="hoverDoor = true"
          @mouseleave="hoverDoor = false"
        />
      </map>
      <img
        class="img-overlay img-front"
        src="/assets/images/map.webp"
        usemap="#mapframe"
        alt
      />
    </div>
    <div class="frame-overlay"></div>
    <div
      class="frame-content container-fluid fade-in"
      :class="{ 'fade-out': startZoom }"
    >
      <div class="frame-text">
        <h1 class="frame-heading mb-4">
          MAGNIFICENT HALL OF<br />
          ASGARD AWAITS
        </h1>
        <p class="lead">The great adventure of ValhallaVerse begins!</p>
        <p class="lead">
          Create your deck and build a strategy<br />
          with Warrior & Skill Card NFTs<br />
          that will lead you to victory!
        </p>
        <p class="lead">
          Let ‘Handbook’ guide you on your journey<br />
          to the ultimate glory.
        </p>
      </div>
    </div>
    <modal name="book" width="100vw" height="100vh">
      <div slot="top-right">
        <div class="icon" @click="$modal.hide('book')"></div>
      </div>
      <book></book>
    </modal>
    <div
      class="enter-door"
      @mouseover="hoverDoor = true"
      @mouseleave="hoverDoor = false"
      :class="{ 'fade-out': startZoom }"
    >
      <a @click="startOut">Road to Valhalla</a>
    </div>
    <div
      class="read-book"
      @mouseover="hoverBook = true"
      @mouseleave="hoverBook = false"
      :class="{ 'fade-out': startZoom }"
    >
      <a @click="showModal">Read Handbook</a>
    </div>
  </div>
</template>

<script>
import imageMapResize from 'image-map-resizer';
import Book from '@/components/Book.vue';

export default {
  data() {
    return {
      hoverBook: false,
      hoverDoor: false,
      startZoom: false,
    };
  },
  mounted() {
    window.addEventListener('resize', this.windowResize);
    setTimeout(() => imageMapResize(), 50);

    setInterval(() => {
      if (!(this.hoverDoor || this.hoverBook)) {
        this.hoverDoor = true;
        this.hoverBook = true;
        setTimeout(() => {
          this.hoverDoor = false;
          this.hoverBook = false;
        }, 500);
      }
    }, 5000);
  },
  updated() {
    setTimeout(() => imageMapResize(), 50);
  },
  unmounted() {
    window.removeEventListener('resize', this.windowResize);
  },
  methods: {
    windowResize(e) {
      console.log('res');
      imageMapResize();
    },
    showModal() {
      if (this.$device.mobile) {
        window.open('/valhallaverse-book.pdf', '_blank');
      } else {
        this.$modal.show('book');
      }
    },
    startOut() {
      console.log('startOut');
      this.startZoom = true;
      setTimeout(() => this.$router.push('/details'), 1000);
    },
  },
  components: {
    Book,
  },
};
</script>

<style lang="scss" scoped>
.frame-inside {
  position: relative;
  overflow: hidden;
  .frame-bg {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    .frame-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      transition: transform 1s ease-in-out;
    }
    .img-overlay {
      object-fit: cover;
      position: absolute;
      height: 100%;
      min-height: 100vh;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      -webkit-transition: -webkit-filter 500ms linear;
      &.shadow {
        -webkit-filter: drop-shadow(0px 0px 1rem #ffeca6);
        filter: drop-shadow(0px 0px 1rem #ffeca6);
      }
    }
    .img-front {
      z-index: 2;
    }
  }

  .frame-content {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .frame-text {
      padding-left: 3rem;
      margin-bottom: 3rem;
      .frame-heading {
        color: #ffeec2;
        text-transform: uppercase;
      }
      p {
        margin-bottom: 2rem;
      }
    }
    @media (max-width: 767.98px) {
      justify-content: flex-start;
      .frame-text {
        padding-left: 1rem;
        margin-top: 6rem;
        p {
          margin-bottom: 0.5rem;
        }
      }
    }
  }
  .enter-door {
    color: #ffeec2;
    position: absolute;
    left: 56%;
    left: max(56%, 600px);
    top: 41%;
    transform: translateY(-50%);
    z-index: 5;
    text-decoration: none;
    font-size: 1rem;
    font-size: max(1rem, 18px);
    line-height: 20px;
    cursor: pointer;
    text-shadow: 0 0 10px black;
    border-bottom: 1px solid #ffeec2;
    @media (max-width: 767.98px) {
      top: 55%;
      left: 54%;
    }
    &:after {
      position: absolute;
      content: url('~@/assets/images/watch-trailer.png');
      left: -31px;
      top: 100%;
      height: 76px;
      width: 13px;
    }
    &:hover {
      color: #fff !important;
    }
  }
  .read-book {
    color: #ffeec2;
    position: absolute;
    left: 53%;
    left: max(53%, 600px);
    padding-left: 2rem;
    top: 81%;
    transform: translateY(-50%);
    z-index: 5;
    text-decoration: none;
    font-size: 1rem;
    font-size: max(1rem, 18px);
    line-height: 20px;
    cursor: pointer;
    text-shadow: 0 0 10px black;
    border-bottom: 1px solid #ffeec2;
    @media (max-width: 767.98px) {
      left: 54%;
    }
    &:hover {
      color: #fff !important;
    }
  }
  .vm--overlay {
    backdrop-filter: blur(20px);
  }
  .flip_page_double + div {
    background-color: none !important;
  }
  .zoom {
    transform: scale(3); /* (x * 100% zoom) */
  }
  .fade-out {
    opacity: 0;
    transition: opacity 0.5s linear;
  }
}
</style>
